import { NavLink, useLocation } from "react-router-dom";
import { House, ArrowsLeftRight, Package, ShoppingCart, Truck, ClipboardText } from "@phosphor-icons/react";

const items = [
  { to: "/", icon: House, label: "Tableau" },
  { to: "/mouvements", icon: ArrowsLeftRight, label: "Mouvements" },
  { to: "/stock", icon: Package, label: "Stock" },
  { to: "/commandes", icon: ShoppingCart, label: "Commandes" },
  { to: "/fournisseurs", icon: Truck, label: "Fournisseurs" },
  { to: "/inventaire", icon: ClipboardText, label: "Inventaire" },
];

export default function Sidebar() {
  const loc = useLocation();
  return (
    <aside
      data-testid="sidebar"
      className="hidden md:flex flex-col fixed left-0 top-0 bottom-0 w-[240px] bg-white border-r border-[color:var(--border-soft)] z-30"
    >
      <div className="px-6 py-7 border-b border-[color:var(--border-soft)]">
        <div className="font-heading text-xl font-semibold text-[color:var(--text-primary)]">
          Cabinet<span className="text-[color:var(--brand)]">·Stock</span>
        </div>
        <div className="text-xs uppercase tracking-[0.15em] text-[color:var(--text-muted)] mt-1 font-bold">
          Gestion consommables
        </div>
      </div>
      <nav className="flex-1 px-3 py-4 space-y-1">
        {items.map((item) => {
          const active = loc.pathname === item.to;
          const Icon = item.icon;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`nav-${item.label.toLowerCase()}`}
              className={`flex items-center gap-3 px-4 h-14 rounded-2xl press-scale transition-colors ${
                active
                  ? "bg-[color:var(--brand)] text-white"
                  : "text-[color:var(--text-secondary)] hover:bg-[color:var(--brand-muted)]"
              }`}
            >
              <Icon size={26} weight={active ? "fill" : "regular"} />
              <span className="font-medium text-[15px]">{item.label}</span>
            </NavLink>
          );
        })}
      </nav>
      <div className="px-6 py-5 text-xs text-[color:var(--text-muted)] border-t border-[color:var(--border-soft)]">
        v1.0 — tablette prêt
      </div>
    </aside>
  );
}

export function MobileBottomNav() {
  const loc = useLocation();
  return (
    <nav
      data-testid="bottom-nav"
      className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-[color:var(--border-soft)] z-30 flex"
    >
      {items.slice(0, 5).map((item) => {
        const active = loc.pathname === item.to;
        const Icon = item.icon;
        return (
          <NavLink
            key={item.to}
            to={item.to}
            className={`flex-1 flex flex-col items-center justify-center h-20 gap-1 ${
              active ? "text-[color:var(--brand)]" : "text-[color:var(--text-muted)]"
            }`}
          >
            <Icon size={28} weight={active ? "fill" : "regular"} />
            <span className="text-[11px] font-medium">{item.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}
